import { useTranslation } from 'react-i18next';

export function useFeatureCopy(namespace: string) {
  const { t, i18n } = useTranslation('common');
  const isArabic = i18n.resolvedLanguage === 'ar' || i18n.language.startsWith('ar');

  return {
    isArabic,
    language: isArabic ? ('ar' as const) : ('en' as const),
    copy: (key: string, english: string, arabic: string): string =>
      t(`features.${namespace}.${key}`, { defaultValue: isArabic ? arabic : english }),
  };
}
